import {BatchTaskService} from './batchTaskService.js';
import {UndoService} from './undoService.js';
import {DatawatchService} from './datawatchService.js';
import {IntegrationService} from './integrationService.js';
import {DataRetentionService} from './dataRetentionPolicy.js';
import {DataLockService} from './datalockService.js';
import {DataHandlerService} from './dataHandlerService.js';
import {DataFilteringService} from './dataFilteringService.js';
import {GPSFilteringService} from './gpsFilteringService.js';
import {CalcPreferenceService} from './calcPreferenceService.js';
import {CustomDataHandlerService} from './customDataHandlerService.js';
import {DataTransformRuleSetService} from './dataTransformRuleSetService.js';
import {ImportService} from './importService.js';
import {DataLinkService} from './datalinkService.js';
import {GPSService} from './gpsService.js';
import {FuelService} from './fuelService.js';
import {DistanceSummaryService} from './distanceSummaryService.js';
import {TripService} from './tripService.js';
import {DataBlockService} from './dataBlockService.js';
import {TimeToolService} from './timeToolService.js';
import {AdminDataService} from './adminDataService.js';
import {MigrationService} from './migrationService.js';

export var DataManagementService = {
	batchTaskService: null,
	undoService: null,
	datawatchService: null,
	integrationService: null,
	dataRetentionService: null,
	dataLockService: null,
	dataHandlerService: null,
	dataFilteringService: null,
	gpsFilteringService: null,
	calcPreferenceService: null,
	customDataHandlerService: null,
	dataTransformRuleSetService: null,
	importService: null,
	datalinkService: null,
	gpsService: null,
	fuelService: null,
	distanceSummaryService: null,
	tripService: null,
	dataBlockService: null,
	timeToolService: null,
	adminDataService: null,
	migrationService: null,

	getBatchTaskService: function(){
		if (!this.batchTaskService) {
			this.batchTaskService = new BatchTaskService();
		}
		return this.batchTaskService;
	},

	getUndoService: function(){
		if (!this.undoService) {
			this.undoService = new UndoService();
		}
		return this.undoService;
	},	
	
	getDatawatchService: function(){
		if (!this.datawatchService) {
			this.datawatchService = new DatawatchService();
		}
		return this.datawatchService;
	},
	
	getIntegrationService: function(){
		if (!this.integrationService) {
			this.integrationService = new IntegrationService();
		}
		return this.integrationService;
	},
	
	getDataRetentionService: function(){
		if (!this.dataRetentionService) {
			this.dataRetentionService = new DataRetentionService();
		}
		return this.dataRetentionService;
	},	
	
	getDataLockService: function(){
		if (!this.dataLockService) {
			this.dataLockService = new DataLockService();
		}
		return this.dataLockService;
	},		
	
	getDataHandlerService: function(){
		if (!this.dataHandlerService) {
			this.dataHandlerService = new DataHandlerService();
		}
		return this.dataHandlerService;
	},
	
	getDataFilteringService: function(){
		if (!this.dataFilteringService) {
			this.dataFilteringService = new DataFilteringService();
		}
		return this.dataFilteringService;
	},
	
	getGPSFilteringService: function(){
		if (!this.gpsFilteringService) {
			this.gpsFilteringService = new GPSFilteringService();
		}
		return this.gpsFilteringService;
	},
	
	getCalcPreferences: function(){
		if (!this.calcPreferenceService) {
			this.calcPreferenceService = new CalcPreferenceService();
		}
		return this.calcPreferenceService;
	},
	
	getCustomDataHandlerService: function(){
		if (!this.customDataHandlerService) {
			this.customDataHandlerService = new CustomDataHandlerService();
		}
		return this.customDataHandlerService;
	},

	getDataTransformRuleSetService: function(){
		if (!this.dataTransformRuleSetService) {
			this.dataTransformRuleSetService = new DataTransformRuleSetService();
		}
		return this.dataTransformRuleSetService;
	},
	
	getImportService: function(){
		if (!this.importService) {
			this.importService = new ImportService();
		}
		return this.importService;
	},
	
	getDataLinkService: function(){
		if (!this.datalinkService) {
			this.datalinkService = new DataLinkService();
		}
		return this.datalinkService;
	},
	
	getGPSService: function(){
		if (!this.gpsService) {
			this.gpsService = new GPSService();
		}
		return this.gpsService;
	},
	
	getFuelService: function(){
		if (!this.fuelService) {
			this.fuelService = new FuelService();
		}
		return this.fuelService;
	},
	
	getDistanceSummaryService: function() {
		if (!this.distanceSummaryService) {
			this.distanceSummaryService = new DistanceSummaryService();
		}
		return this.distanceSummaryService;
	},
	
	getTripService: function() {
		if (!this.tripService) {
			this.tripService = new TripService();
		}
		return this.tripService;
	},
	
	getDataBlockService: function() {
		if (!this.dataBlockService) {
			this.dataBlockService = new DataBlockService();
		}
		return this.dataBlockService;
	},	

	getTimeToolService: function() {
		if (!this.timeToolService) {
			this.timeToolService = new TimeToolService();
		}
		return this.timeToolService;
	},
	
	getAdminDataService: function() {
		if (!this.adminDataService) {
			this.adminDataService = new AdminDataService();
		}
		return this.adminDataService;
	},

	getMigrationService: function() {
		if (!this.migrationService) {
			this.migrationService = new MigrationService();
		}
		return this.migrationService;
	}
	
};

